module.exports = __webpack_public_path__ + "static/idmagic_0-8fdb5ae47089f6274d0a76e7ef57ff50.jpg";